import { Grow } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';

// @ts-expect-error: written according to https://v5.mui.com/material-ui/react-dialog/#transitions
export const DialogTransition: React.FC = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Grow ref={ref} {...props} />;
});
